import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@ngneat/reactive-forms';
import { saveAs } from 'file-saver';
import { CodaltComponent } from 'src/app/codalt.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog-service/confirm-dialog.service';
import { ProjectService } from 'src/app/services/project.service';
import { RealisationService } from 'src/app/services/realisation.service';

@Component({
    selector: 'app-weekreport-pdf-options-dialog',
    templateUrl: './weekreport-pdf-options-dialog.component.html',
    styleUrls: ['./weekreport-pdf-options-dialog.component.scss'],
    standalone: false,
})
export class WeekreportPdfOptionsDialogComponent extends CodaltComponent implements OnInit {
    combine = false;

    downloadingPdf = false;

    fcOnlyWeekTotals = new FormControl(false);
    fcNoHours = new FormControl(false);
    fcNoComments = new FormControl(false);
    fcNoAsphalt = new FormControl(false);
    fcNoCars = new FormControl(true);

    constructor(
        public dialogRef: MatDialogRef<WeekreportPdfOptionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            projectId;
            week;
            year;
            combine?: boolean;
        },
        private realisationService: RealisationService,
        private confirmDialog: ConfirmDialogService,
        private projectService: ProjectService
    ) {
        super();
        this.combine = this.data.combine || false;
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.fcNoHours.valueChanges.subscribe(noHours => {
                this.fcOnlyWeekTotals.setDisable(noHours, { emitEvent: false });
            })
        );
        this.subscriptions.add(
            this.fcOnlyWeekTotals.valueChanges.subscribe(onlyWeekTotals => {
                this.fcNoHours.setDisable(onlyWeekTotals, { emitEvent: false });
            })
        );
    }

    pdf() {
        this.downloadingPdf = true;

        if (this.combine) {
            this.subscriptions.add(
                this.projectService
                    .genPdfOfWeekreports(
                        this.data.projectId,
                        this.fcOnlyWeekTotals.value,
                        this.fcNoHours.value,
                        this.fcNoComments.value,
                        this.fcNoAsphalt.value,
                        this.fcNoCars.value
                    )
                    .subscribe(() => {
                        this.confirmDialog
                            .confirm({
                                title: 'Weekrapport aangevraagd',
                                text: `Er is een rapport aangevraagd voor het project <b>${this.data.projectId}</b>. Dit wordt verstuurd naar <b>${this.LocalStorage.user.email}</b>`,
                                confirm: 'Sluiten',
                                cancel: null,
                            })
                            .then(() => {
                                this.downloadingPdf = false;
                                this.dialogRef.close({ success: true });
                            });
                    })
            );

            return;
        }

        const filename = `Weekrapport_${this.data.projectId}-week_${this.data.week}-${this.data.year}.pdf`;
        this.subscriptions.add(
            this.realisationService
                .getWeekReportPdf(
                    this.data.projectId,
                    this.data.week,
                    this.data.year,
                    this.fcOnlyWeekTotals.value,
                    this.fcNoHours.value,
                    this.fcNoComments.value,
                    this.fcNoAsphalt.value,
                    this.fcNoCars.value
                )
                .subscribe(
                    (data: Blob) => {
                        saveAs(data, filename);

                        this.downloadingPdf = false;

                        this.dialogRef.close({ success: true });
                    },
                    () => {
                        this.downloadingPdf = false;
                        this.confirmDialog
                            .confirm({
                                title: 'Er is iets foutgegaan',
                                text: `Fout bij het aanmaken van de pdf`,
                                confirm: 'Oké',
                                cancel: null,
                            })
                            .then(
                                () => {
                                    this.dialogRef.close({ success: false });
                                },
                                () => {}
                            );
                        this.dialogRef.close({ success: false });
                    }
                )
        );
    }

    cancel() {
        this.dialogRef.close(null);
    }
}
